import { useContext } from 'react';
import { createContext } from 'react';
import useResponsiveValues from '../../../responsive-values/useResponsiveValues';

import { FlexRowProps } from '../@types/FlexLayoutProps';

export const FlexRowContext = createContext<FlexRowProps>({} as FlexRowProps);

FlexRowContext.displayName = 'FlexRow';

export function FlexRowProvider(props: FlexRowProps) {
	const value = useResponsiveValues(props);
	return <FlexRowContext.Provider value={value}>{props.children}</FlexRowContext.Provider>;
}

export function useFlexRow() {
	const context = useContext(FlexRowContext);

	return context;
}
